import { configureStore } from '@reduxjs/toolkit';
import enterpriseReducer from './slices/enterpriseSlice';
import authReducer from './slices/authSlice';
import videoReducer from './slices/videoSlice';
import insightReducer from './slices/insightSlice';
import contentReducer from './slices/contentSlice';

export const store = configureStore({
  reducer: {
    enterprises: enterpriseReducer,
    auth: authReducer,
    videos: videoReducer,
    insights: insightReducer,
    content: contentReducer,
    // Add more reducers here as the application grows
  },
  // Add middleware to check for token expiration, etc.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types (useful for handling non-serializable values)
        ignoredActions: ['auth/login/fulfilled', 'auth/getCurrentUser/fulfilled'],
      },
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
